import { Component, EventEmitter, Output, Input } from '@angular/core';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RippleModule } from 'primeng/ripple';

interface MenuItem {
    label: string;
    icon: string;
    routerLink?: string;
    routerLinkActive: string;
    items?: MenuSubItem[];
}

interface MenuSubItem {
    label: string;
    routerLink?: string;
    routerLinkActive: string;
}

@Component({
    selector: 'app-sidebar-settings',
    templateUrl: './sidebar-settings.html',
    styleUrls: ['./sidebar-settings.scss'],
    imports: [DrawerModule, ButtonModule, AvatarModule, CommonModule, PanelMenuModule, RippleModule]
})

export class SidebarSettingsComponent {
    @Output() onClickLink = new EventEmitter<void>();
    @Input() settingsItems: MenuItem[] = [];

    constructor(private router: Router) { }

    isActiveRoute(route: string): boolean {
        return this.router.url === route || this.router.url.startsWith(route + '/');
    }
}